import { PageHeader as CommonPageHeader, type PageHeaderProps } from '@monorepo/common';

function PageHeader(props: PageHeaderProps) {
  return <CommonPageHeader {...props} />;
}

export default PageHeader;
